"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var window_1 = __importDefault(require("~/components/users/estimates/requests/unread_request/window"));
var unread_request_store_1 = __importDefault(require("~/stores/users/estimates/requests/unread_request_store"));
var Index = function () { return (react_1.default.createElement(mobx_react_1.Provider, { unreadRequestStore: new unread_request_store_1.default() },
    react_1.default.createElement(window_1.default, null))); };
exports.default = Index;
